import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, MenuItem } from '@mui/material';
import koLocale from 'date-fns/locale/ko';
import DateAdapter from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import SearchCodeSelectbox from '../common/form/selectbox/SearchCodeSelectbox';
import {
  firstDayofYear,
  getFirstDayOfYear,
  getLastDayOfYear,
  lastDayofYear,
  subYearStrDt,
} from '../../utils/calcDatetime';
//----------------------------------------------------------------------------
//----------------------------------------------------------------------------
export const ChanceFailListBox = ({ formik }) => {
  const [searchStrtDt, setSearchStrtDt] = useState(null);
  const [searchEndDt, setSearchEndDt] = useState(null);

  useEffect(() => {
    if (formik.values.searchStrtDt) {
      setSearchStrtDt(formik.values.searchStrtDt);
    }
    if (formik.values.searchEndDt) {
      setSearchEndDt(formik.values.searchEndDt);
    }
  }, [formik.values.searchStrtDt, formik.values.searchEndDt]);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  // const handleChangeEndDt = (year) => {
  //   const strDt = subYearStrDt(year);

  //   formik.setFieldValue('searchStrtDt', strDt);
  //   formik.setFieldValue('searchEndDt', new Date());
  // };

  const handleChangeThisYear = () => {
    formik.setFieldValue('searchStrtDt', firstDayofYear);
    formik.setFieldValue('searchEndDt', lastDayofYear);
  };
  const handleChangeLastYear = () => {
    const paramDate = subYearStrDt(1);

    const strDt = getFirstDayOfYear(paramDate);
    const endDt = getLastDayOfYear(paramDate);

    formik.setFieldValue('searchStrtDt', strDt);
    formik.setFieldValue('searchEndDt', endDt);
  };

  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          alignItems: 'center',
          my: 1,
        }}
      >
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mr: 2,
          }}
          onSubmit={formik.handleSubmit}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
              '& > :not(style)': { m: 1, width: '20ch' },
            }}
          >
            <SearchCodeSelectbox
              formik={formik}
              variant="standard"
              name="searchPrjImpt"
              label="프로젝트 중요도"
              required={false}
              fullWidth
              filterObject={{
                blcCd: 'BASE',
                mlcCd: 'FORCAST',
                slcCd: 'PRJ_IMPT',
              }}
            />
            <TextField
              variant="standard"
              required={false}
              select
              id="searchKeyword"
              name="searchKeyword"
              label="검색키워드"
              value={formik.values.searchKeyword}
              onChange={formik.handleChange}
              error={
                formik.touched.searchKeyword &&
                Boolean(formik.errors.searchKeyword)
              }
              helperText={
                formik.touched.searchKeyword && formik.errors.searchKeyword
              }
            >
              {/* <MenuItem value="">검색키워드</MenuItem> */}
              <MenuItem value="cstNm">사업명</MenuItem>
              <MenuItem value="vendorCmpNm">매출처명</MenuItem>
              <MenuItem value="crtDptNm">부서</MenuItem>
              <MenuItem value="crtNm">영업담당자</MenuItem>
              <MenuItem value="cstStatus">상태</MenuItem>
            </TextField>
            <TextField
              variant="standard"
              required={false}
              id="searchWords"
              name="searchWords"
              label="검색어"
              value={formik.values.searchWords}
              onChange={formik.handleChange}
              error={
                formik.touched.searchWords && Boolean(formik.errors.searchWords)
              }
              helperText={
                formik.touched.searchWords && formik.errors.searchWords
              }
            />
          </Box>
          <Box>
            <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
              <DatePicker
                label="매출 시작일"
                inputFormat={'yyyy-MM-dd'}
                mask={'____-__-__'}
                id="searchStrtDt"
                name="searchStrtDt"
                value={searchStrtDt}
                onChange={(newValue) => {
                  setSearchStrtDt(newValue);
                  onChangeDate(newValue, 'searchStrtDt');
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    fullWidth
                    error={
                      formik.touched.searchStrtDt &&
                      Boolean(formik.errors.searchStrtDt)
                    }
                    helperText={
                      formik.touched.searchStrtDt && formik.errors.searchStrtDt
                    }
                  />
                )}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ mx: 2 }}>
            <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
              <DatePicker
                label="매출 종료일"
                inputFormat={'yyyy-MM-dd'}
                mask={'____-__-__'}
                id="searchEndDt"
                name="searchEndDt"
                value={searchEndDt}
                onChange={(newValue) => {
                  setSearchEndDt(newValue);
                  onChangeDate(newValue, 'searchEndDt');
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    fullWidth
                    error={
                      formik.touched.searchEndDt &&
                      Boolean(formik.errors.searchEndDt)
                    }
                    helperText={
                      formik.touched.searchEndDt && formik.errors.searchEndDt
                    }
                  />
                )}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ mr: 2 }}>
            <Button
              variant="outlined"
              color="info"
              onClick={handleChangeThisYear}
            >
              금년
            </Button>
            <Button
              variant="outlined"
              color="info"
              onClick={handleChangeLastYear}
              sx={{ mx: 1 }}
            >
              작년
            </Button>
          </Box>

          <Box>
            <Button
              type="submit"
              color="info"
              variant="contained"
              disabled={formik.isSubmitting}
            >
              검색
            </Button>
          </Box>
        </Box>
      </Box>
    </div>
  );
};
